export class AddNewUtilityModel {
  name: string;
  description: string;
  icon: File | null;
  iconPath: string | null;
  color: string;
  moduleImage: File | null;


  constructor(data: { name?: string; description?: string; icon?: File | null; color?: string; moduleImage?: File | null; iconPath?: string }) {
    this.name = data.name ?? '';
    this.description = data.description ?? '';
    this.iconPath = data.iconPath ?? null;
    this.icon = data.icon ?? null;
    this.color = data.color ?? '';
    this.moduleImage = data.moduleImage ?? null;
  }
}

export class ModuleDetails {
  name: string;
  description: string;
  iconPath: string;
  imagePath: string;
  color: string;
}
